import { render, staticRenderFns } from "./CategoryInlineForm.vue?vue&type=template&id=6533ba65"
import script from "./CategoryInlineForm.vue?vue&type=script&lang=js"
export * from "./CategoryInlineForm.vue?vue&type=script&lang=js"
import style0 from "./CategoryInlineForm.vue?vue&type=style&index=0&id=6533ba65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports